<template>
  <div>
    <NuxtRouteAnnouncer />
    <NuxtLoadingIndicator color="rgb(23, 70, 162)" />
    <NuxtLayout>
      <PrimeToast position="bottom-right" class="max-w-[90vw]" />
      <NuxtPage />
      <PrimeConfirmPopup></PrimeConfirmPopup>
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
// Define the route to ensure NuxtPage is recognized
useHead({
  htmlAttrs: {
    lang: 'en',
  },
});
</script>
